import { render, staticRenderFns } from "./data--form.vue?vue&type=template&id=ee5288dc&"
import script from "./data--form.vue?vue&type=script&lang=js&"
export * from "./data--form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports